<template>
    <div :class="['field field--textarea']">
        <div>
            <label
                :for="id"
                class="title bold static-label"
            >
                {{ label }}
            </label>
            <textarea
                :id="id"
                :rows="rows"
                :value="value"
                :placeholder="placeholder"
                @input="$emit('input', $event.target.value)"
                :required="required"
            ></textarea>
        </div>
        <small
            v-if="errors.length"
            v-html="errors.join('<br/>\n')"
            class="text-danger"></small>
        <small v-else-if="hint">{{ hint }}</small>
    </div>
</template>

<script>
    export default {
        name: 'CoreTextarea',
        data() {
            return {
                error: false,
                type: null
            }
        },
        props: {
            id: {
                type: String,
                default() { return `text-input-${this._uid}`}
            },
            label: {
                type: String,
                default: ''
            },
            hint: {
                type: String,
                default: ''
            },
            rows: {
                type: Number,
                default: 10
            },
            placeholder: {
                type: String,
                defualt: ''
            },
            value : {
                type: String,
                required: false,
                default: ''
            },
            required: {
                type: Boolean,
                default: false
            },
            errors: {
                type: Array,
                default: () => []
            }
        }
    }
</script>

<style lang="scss" scoped>
.field--textarea {
    & > div {
        position: relative;
    }

    .static-label {
        display: block;
        margin-bottom: 0.5rem;
        color: var(--text-dark);
    }

    textarea {
        display: inline-flex;
        // border: 1px solid var(--border-grey);

        width: 100%;
        padding: 1rem;
        border: none;
        border-radius: 4px;
        box-shadow: inset 0 0 0 1px  var(--border-grey-50);
        font-size: 1rem;

        &:focus {
            border-color: var(--border-grey-dark);
        }
    }

    input::placeholder {
        opacity: 0;
    }

    input:focus,
    &.is-focused input {
        &::placeholder {
            opacity: 1;
        }
    }

    small {
        display: block;
        margin-top: 0.5rem;

        &.text-danger {
            color: var(--system-red);
        }
    }
}
</style>
